module.exports = __webpack_public_path__ + "static/hauenstein-logowhite-3a11eb385b9a075d6cdfb1b292cec446.png";